<span
  [ngbTooltip]="tooltipTemplate"
  [placement]="'top'"
  triggers="manual"
  [disableTooltip]="disabled()"
  [popperOptions]="popperOptionsWithOffset()"
  (shown)="onShown()"
  (hidden)="onHidden()"
  [tooltipClass]="'ui-tooltip__content'"
  container="body"
>
  <ng-content />
</span>

<ng-template #tooltipTemplate>
  @if (text()) {
    <ng-container>{{ text() }}</ng-container>
  }
  @if (tooltipContent(); as content) {
    <ng-template [ngTemplateOutlet]="content" />
  }
</ng-template>
